/** Curated, visually distinct palette - avoids random/muddy hash colors. */
const ROUTE_COLOR_PALETTE = [
  '#F4841A', // orange (brand default)
  '#2563EB', // blue
  '#16A34A', // green
  '#DC2626', // red
  '#7C3AED', // violet
  '#0891B2', // cyan
  '#DB2777', // pink
  '#CA8A04', // amber
  '#4F46E5', // indigo
  '#059669', // emerald
  '#EA580C', // deep orange
  '#9333EA', // purple
];

/** Deterministic color per route id, so the same route always renders the same color across the
 * routes table and its detail/build map - no backend "color" field needed for this. */
export function getRouteColor(routeId: string): string {
  let hash = 0;
  for (let i = 0; i < routeId.length; i += 1) {
    hash = (hash * 31 + routeId.charCodeAt(i)) >>> 0;
  }
  return ROUTE_COLOR_PALETTE[hash % ROUTE_COLOR_PALETTE.length];
}
